const appInnerRouter = [
  {
    path: '/m-orgnize-info',
    name: 'm-orgnize-info',
    meta: { title: '组织信息' },
    component: () =>
      import(/* webpackChunkName: "about" */ '@/pages/phone/information/organizetion')
  }
];
export default appInnerRouter;
